import React from "react";
import Loader from "./Loader";

const PageLoader = () => {
  return (
    <div style={{ height: "100vh", width: "100vw" }}>
      <Loader loading size="lg" position="fixed" />
    </div>
  );
};

export default PageLoader;